import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import React, { useContext, useState } from "react";

import {
  dashboardRemove,
  zoneRemove,
  removeLearnApi,
  scenarioDelete,
  addNewScenario,
  deleteAutomation,
  addNewAutomation,
  automationList,
} from "../api";
import { removeDashboard, removeZone } from "../redux";
import { withRouter } from "react-router-dom";
import { ScenarioSection } from "../context/ScenarioContext";
import { DeviceMineContext } from "../context/DeviceMineContext";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  AutomationContextProvider,
  AutomationSection,
} from "../context/AutomationContext";
const AlertComp = (props) => {
  const { t } = useTranslation();
  const {
    message,
    type,
    question,
    id,
    request,
    toggleAlert,
    serial,
    closeModal,
    title,
    icon,
    uid,
    setScenarioId,
    deviceSerial,
    setSubmitAlert,
    setOpenAddAutomationModal,
  } = props;
  const token = Cookies.get("token");

  const dispatch = useDispatch();
  const { scenarioPage, ShowHideFunction } = useContext(ScenarioSection);
  // const { automationPage, AutomationShowHideFunc } =
  //   useContext(AutomationSection);

  const [showToast, setShowToast] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitHandler = () => {
    const data = new FormData();
    if (request === "dashboard") {
      data.append("dashboard", id);
      dashboardRemove(data, token)
        .then((res) => {
          dispatch(removeDashboard({ id: id }));
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "zone") {
      data.append("zone", id);
      zoneRemove(data, token)
        .then(() => {
          dispatch(removeZone({ id: id }));
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "deleteLearn") {
      data.append("serial", serial);
      data.append("widget", id);
      removeLearnApi(data, token)
        .then((res) => {
          // console.log(res);
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "deleteScenario") {
      const data = new FormData();
      data.append("scenario_id", id);

      scenarioDelete(data, token)
        .then((result) => {})
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 2000);
          }
        });
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        question: false,
        message: t(" با موفقیت حذف شد."),
        type: "Success",
      }));
      setTimeout(() => {
        setShowAlert(() => ({
          show: false,
        }));

        toggleAlert();
        closeModal(false);
        // ShowHideFunction("firstPage");
      }, 2000);
    } else if (request === "addNewScenario") {
      const data = new FormData();
      data.append("title", title);
      data.append("icon", icon);
      addNewScenario(data, token)
        .then((result) => {
          setScenarioId(result.data.data);
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            question: false,
            message: t("با موفقیت اضافه شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert(() => ({
              show: false,
            }));

            toggleAlert();
            ShowHideFunction("firstPage");
          }, 2000);
        })
        .catch((err) => {
          if (err.response.status === 400) {
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              question: false,
              message: t("با موفقیت اضافه شد."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert(() => ({
                show: false,
              }));

              toggleAlert();
              ShowHideFunction("firstPage");
            }, 3000);
          }
        });
    } else if (request === "ActionDeleteScenario") {
    } else if (request === "DeleteDeviceDisjoint") {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var formdata = new FormData();
      formdata.append("serial", deviceSerial);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch("https://assessn.mmaviot.com/api/device_disjoin", requestOptions)
        .then((response) => response.text())
        .then((res) => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            question: false,
            message: t(" با موفقیت حذف شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert(() => ({
              show: false,
            }));

            toggleAlert(true);
          }, 3000);
        })
        .catch((error) => console.log("error", error));
    } else if (request === "DeleteAutomation") {
      data.append("title", title);
      data.append("icon", icon);
      data.append("automation_id", uid);

      deleteAutomation(data, token)
        .then(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            question: false,
            message: t(" با موفقیت حذف شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert(() => ({
              show: false,
            }));
            toggleAlert();
            closeModal(false);
          }, 2000);
        })
        .catch((error) => console.log("error", error));
    } else if (request === "addAutomationNew") {
      const data = new FormData();
      data.append("title", title);
      data.append("icon", icon);
      addNewAutomation(data, token)
        .then(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            question: false,
            message: t("با موفقیت اضافه شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert(() => ({
              show: false,
            }));
            toggleAlert();
          }, 2000);
        })
        .catch((error) => console.log("error", error));
    }
  };

  const cancelHandler = () => {
    toggleAlert();
  };

  return (
    <div className="p-3 align-items-center justify-content-around shortcut">
      {tooltipText && <div className="toast-tooltip w-75  ">{tooltipText}</div>}
      <div
        className={`alertMessage alertBorder${type} d-flex justify-content-between align-items-center py-2 px-2`}
      >
        <div className="d-flex align-items-center">
          <span
            className={`alertIcon alertBg${type} d-block ml-3 d-flex justify-content-center align-items-center`}
          >
            <span
              className={`d-block bg-white fn d-flex justify-content-center align-items-center rounded-circle ${
                type === "Success" ? "icon-ok" : "icon-cancel"
              }`}
            ></span>
          </span>
          <p className="m-0 fn12 p-1">{message}</p>
        </div>
        {question ? (
          <div className="d-flex justify-content-between align-items-center">
            <span
              onClick={cancelHandler}
              className="d-block alertIconDelOk cursor bg-white text-secondary rounded-circle d-flex justify-content-center align-items-center mx-2"
              style={{ border: "1px solid gray" }}
            >
              <i className="icon-cancel fn"></i>
            </span>
            <span
              onClick={submitHandler}
              className="d-block alertIconDelOk cursor bg-white text-success rounded-circle d-flex justify-content-center align-items-center"
              style={{ border: "1px solid green" }}
            >
              <i className="icon-ok fn"></i>
            </span>
          </div>
        ) : (
          <i className="icon-cancel fn10"></i>
        )}
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          setScenarioId={setScenarioId}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </div>
  );
};

const Alert = withRouter(AlertComp);

export { Alert };
